import { Box, Text, Paragraph } from "grommet";
import { RasterClass } from "../models";
import styled from "styled-components";

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  width: 24rem;

  &.compact {
    width: 18rem;
    padding: 0.6rem 1rem;
  }

  &.tiny {
    width: 12rem;
    padding: 0;
  }
`;

const Item = styled(Box)`
  border-top: 0.1rem solid var(--warm-gray-300);
  display: flex;
  flex-direction: row;
  padding: 1rem;

  &:first-child {
    border-top: none;
  }

  &.compact {
    border-top: none;
    padding: 0.5rem 0;
  }

  &.tiny {
    border-top: none;
    padding: 0.2rem 0;
  }
`;

const Swatch = styled(Box)<{ bgColor: string }>`
  background-color: ${props => props.bgColor};
  border-radius: var(--border-radius);
  flex: 0 0 0.8rem;

  &.compact {
    flex: 0 0 1.4rem;
    margin: 2px 0;
  }

  &.tiny {
    flex: 0 0 1rem;
    margin: 1px 0;
  }
`;

const MapClassLegend = ({
  classes,
  compact,
  smallLabel = false
}: {
  classes: ReadonlyArray<RasterClass>;
  compact: boolean;
  smallLabel?: boolean;
}) => (
  <Container className={smallLabel ? "tiny" : compact ? "compact" : ""}>
    {classes.map(({ label, color, definition }, idx) => (
      <Item key={idx} className={smallLabel ? "tiny" : compact ? "compact" : ""}>
        <Swatch bgColor={color} className={smallLabel ? "tiny" : compact ? "compact" : ""} />
        <Box direction="column" pad={{ left: smallLabel ? ".4rem" : "1rem" }} gap=".5rem">
          <Text size={smallLabel ? "1rem" : "1.4rem"} weight={700} color="#000">
            {label}
          </Text>
          {!compact && <Paragraph size="small">{definition}</Paragraph>}
        </Box>
      </Item>
    ))}
  </Container>
);

export default MapClassLegend;
